<svelte:options tag="app-banner" />

<div class:hidden class:indented class:permanent class="app-banner level-{level}">
  <div class="banner-text">{text || 'Sorry, something went wrong.'}</div>
  {#if linkurl}
    <div class="banner-link">
      <a href={linkurl}>
        {#if linktext}{linktext}{:else}{linkurl}{/if}
      </a>
    </div>
  {/if}

  {#if !permanent}
    <span on:click={dismissHandler}>
      <slot name="dismiss">
        <div class="dismiss-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-label="banner dismiss icon">
            <path
              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216
              0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3
              69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17
              0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17
              0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
            />
          </svg>
        </div>
      </slot>
    </span>
  {/if}
</div>

<script>
  import { get_current_component } from 'svelte/internal'
  export let id
  export let level
  export let text
  export let linkurl
  export let linktext
  export let dismissed = false
  export let menuexpanded
  export let permanent = false

  $: indented = menuexpanded
  $: hidden = dismissed
  $: permanent = (permanent === '' && true) || permanent || false

  const component = get_current_component()

  const dismissHandler = () => {
    const event = new CustomEvent('app-banner-closed', {
      detail: {
        id: id,
      },
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    component.dispatchEvent(event)
    hidden = true
  }
</script>

<style type="text/scss">
  @import '../shared/color-themes';

  .app-banner.hidden {
    display: none;
  }

  .app-banner.level-info {
    //background-color: $ripe-app-info;
    // background-color: $Pagne-1-4-hsla;
    background-color: var(--ripe-app-info, #29abe2);
    //color: $quasar-dark;
    color: white;
  }
  .app-banner.level-positive {
    // background-color: $ripe-app-positive;
    // background-color: $Pagne-1-2-hsla;
    background-color: var(--ripe-app-positive, #6ebe49);
  }
  .app-banner.level-warning {
    //background-color: $ripe-app-warning;
    // background-color: $Pagne-1-5-hsla;
    background-color: var(--ripe-app-worried, #ff6a00);
    color: white;
  }

  .app-banner.level-accent {
    // background-color: $Pagne-1-5-hsla;
    // background-color: $ripe-app-accent;
    background-color: var(--ripe-app-primary-80, #3d4771);
    color: white;
  }

  .app-banner.level-alarm {
    // background-color: $quasar-negative;
    // background-color: $Pagne-1-3-hsla;
    background-color: var(--ripe-app-warning, #ed1c24);
    color: white;
  }

  .app-banner {
    position: relative;
    display: flex;
    max-height: 150px;
    // margin: 0 0 2px 0;
    border-bottom: 1px solid var(--ripe-app-border-line, #2f2c56);
    font-family: var(--ripe-app-font-family), Helvetica, Arial, sans-serif;
    font-size: 0.875rem;
    font-variation-settings: 'wght' 175;
    font-weight: 175;
    color: white;
    text-rendering: geometricprecision;
    transition: all 0.2s ease-in-out;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
  }

  .app-banner.indented {
    @media only screen and (min-width: 701px) {
      transition: all 0.2s ease-in-out;
    }
  }

  .banner-text {
    overflow: hidden;
    width: 100%;
    padding: 8px 12px;
    max-height: 150px;
    flex-grow: 4;
  }

  .banner-link {
    width: 20vw;
    padding: 8px;
    flex-grow: 1;
    // text-align: right;
    @media (min-width: 1200px) {
      width: 15vw;
    }

    a {
      color: inherit;
      &:visited {
        color: inherit;
      }
    }
  }

  .dismiss-icon {
    height: 24px;
    svg {
      cursor: pointer;
      height: 24px;
      width: 48.16px;
      fill: white;
    }
  }

  .permanent {
    padding-right: 48.16px;
  }
</style>
